import Button from "@material-ui/core/Button"
import IconButton from "@material-ui/core/IconButton"
import AssignmentIcon from "@material-ui/icons/Assignment"
import VideocamIcon from '@material-ui/icons/Videocam';
import CallEndIcon from '@material-ui/icons/CallEnd';
import MicRoundedIcon from '@material-ui/icons/MicRounded';
import MicOffRoundedIcon from '@material-ui/icons/MicOffRounded';
import VideocamOffRoundedIcon from '@material-ui/icons/VideocamOffRounded';
import CallRoundedIcon from '@material-ui/icons/CallRounded';
import FlipCameraAndroidRoundedIcon from '@material-ui/icons/FlipCameraAndroidRounded';
import SendRoundedIcon from '@material-ui/icons/SendRounded';
import MessageIcon from '@material-ui/icons/Message';

import vClasses from "../Video.module.css"
import navClasses from "./BottomNav.module.css"

import { useParams } from "react-router-dom";


import React, { useEffect, useRef, useState } from "react"
import { CopyToClipboard } from "react-copy-to-clipboard"
import Peer from "simple-peer"
import io from "socket.io-client"

import '../App.css';
import './callCard.css'
import Modal from "../Modal/Modal";
import {makeStyles} from "@material-ui/core/styles";
import InputBase from "@material-ui/core/InputBase";
import Divider from "@material-ui/core/Divider";
import Paper from "@material-ui/core/Paper";


const socket = io.connect('https://pacific-brushlands-58264.herokuapp.com', { transports: ['websocket', 'polling', 'flashsocket'] })
// const socket = io.connect('http://localhost:5000', { transports: ['websocket', 'polling', 'flashsocket'] })

const AlwaysScrollToBottom = () => {
    const elementRef = useRef();
    useEffect(() => elementRef.current.scrollIntoView({behavior: "smooth"}));
    return <div ref={elementRef} />;
};

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        background: '#0C0C0CFF',
        color: '#fff'
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
        width: 200,
        color: '#fff'
    },
    inputMessage: {
        // width: 100,
        // height: 2,
        marginLeft: theme.spacing(1),
        flex: 1,
        color: '#fff'
    },
    multilineColor:{
        color:'#fff',
        borderColor: '#fff'
    },
    iconButton: {
        padding: 10,
    },
    copyBtn: {
        '&:hover': {
            backgroundColor: '#8200f8',
            color: '#e2e2e2',
            boxShadow: 'none',
        },
    },
    divider: {
        height: 28,
        margin: 4,
        backgroundColor: '#fff'
    },
}));

const VideoChat = () => {

    const classes = useStyles();
    const { username } = useParams()

    const [ me, setMe ] = useState("")
    const [ stream, setStream ] = useState()
    const [ receivingCall, setReceivingCall ] = useState(false)
    const [ caller, setCaller ] = useState("")
    const [ callerSignal, setCallerSignal ] = useState()
    const [ callAccepted, setCallAccepted ] = useState(false)
    const [ idToCall, setIdToCall ] = useState("")
    const [ callEnded ] = useState(false)
    const [ name, setName ] = useState(username)
    const [ muted, setMuted ] = useState(false)
    const [ showVideo, setShowVideo ] = useState(true)
    const [ flipped, setFlipped ] = useState(false)
    const [ messageState, setMessageState ] = useState({message: '', name: ''})
    const [ chat, setChat ] = useState([])
    const [ showModal, setShowModal ] = useState(false)
    const [ showAnswerModal, setShowAnswerModal ] = useState(false)

    const showModalHandler = () => {
        setShowModal(true)
    }

    const hideModalHandler = () => {
        setShowModal(false)
    }

    // const showAnswerModalHandler = () => {
    //     setShowAnswerModal(true)
    // }

    const hideAnswerModalHandler = () => {
        setShowAnswerModal(!showAnswerModal)
    }

    const onTextChange = (e) => {
        setMessageState({...messageState, name : username, message: e.target.value})
    }

    const onMessageSubmit = (e) => {
        e.preventDefault()

        const {name, message} = messageState
        socket.emit('message', {name, message})

        setMessageState({name, message: ''})
    }

    const myVideo = useRef()
    const userVideo = useRef()
    const connectionRef= useRef()



    useEffect(() => {

        navigator.mediaDevices.getUserMedia({ video: true, audio: true }).then((stream) => {
            setStream(stream)
            myVideo.current.srcObject = stream
        })

        socket.on("me", (id) => {
            setMe(id)
        })

        socket.on("message", ({name, message}) => {
            setChat(chat =>[...chat, {name, message}])
        })

        socket.on("callUser", (data) => {
            setReceivingCall(true)
            setCaller(data.from)
            setName(data.name)
            setCallerSignal(data.signal)
        })

        // if (receivingCall && !callAccepted)
        //     setShowAnswerModal(true)

    // }, [receivingCall, callAccepted])
    }, [])

    const callUser = (e, id) => {
        e.preventDefault()

        const peer = new Peer({
            initiator: true,
            trickle: false,
            stream: stream
        })
        peer.on("signal", (data) => {
            socket.emit("callUser", {
                userToCall: id,
                signalData: data,
                from: me,
                name: name
            })
        })

        peer.on("stream", (stream) => {
            userVideo.current.srcObject = stream
        })

        socket.on("callAccepted", (signal) => {
            setCallAccepted(true)
            peer.signal(signal)
        })

        connectionRef.current = peer
    }

    const answerCall =() =>  {

        setCallAccepted(true)
        setShowAnswerModal(false)

        const peer = new Peer({
            initiator: false,
            trickle: false,
            stream: stream
        })

        peer.on("signal", (data) => {
            socket.emit("answerCall", { signal: data, to: caller })
        })

        peer.on("stream", (stream) => {
            userVideo.current.srcObject = stream
        })

        peer.signal(callerSignal)
        connectionRef.current = peer

    }

    const leaveCall = () => {
        window.location.replace("/");
    }

    const muteUnmute = () => {
        const enabled = myVideo.current.srcObject.getAudioTracks()[0].enabled;
        if (enabled) {
            myVideo.current.srcObject.getAudioTracks()[0].enabled = false;
            console.log('muted')
            setMuted(true)
        } else {
            setMuted(false)
            console.log('unmuted')
            myVideo.current.srcObject.getAudioTracks()[0].enabled = true;
        }
    }

    const showHideVideo = () => {
        const enabled = myVideo.current.srcObject.getVideoTracks()[0].enabled;
        if (enabled) {
            myVideo.current.srcObject.getVideoTracks()[0].enabled = false;
            console.log('video hidden')
            setShowVideo(false)
        } else {
            setShowVideo(true)
            console.log('video shown')
            myVideo.current.srcObject.getVideoTracks()[0].enabled = true;
        }
    }

    let showVideoContainer = "grid"

    if (callAccepted)
        showVideoContainer = "grid"

    const flipVideoHandler = () => {

        setFlipped(!flipped)

    }

    const MessagesComp = (
        <div className={vClasses.MessageContainer} style={{color: "white"}}>
            <h3>Chat with {username}</h3>
            <div className={vClasses.Log}>
                <ul>
                    {
                        chat.map(({name, message}, index) => (
                            <li key={index}>
                                <p>{name}: <span>{message}</span></p>
                            </li>
                        ))
                    }
                    <AlwaysScrollToBottom />
                </ul>
            </div>

            <form onSubmit={onMessageSubmit}>
                <Paper className={[classes.root, vClasses.Paper].join(' ')}>

                    <InputBase
                        className={classes.inputMessage}
                        placeholder="Type your message here"
                        inputProps={{ 'aria-label': 'Enter your name' }}
                        name="message"
                        autoComplete="off"
                        onChange={e => onTextChange(e)}
                        value={messageState.message}
                        label="Message"
                    />

                    <Divider className={classes.divider} orientation="vertical" />

                    <IconButton type='submit' style={{ color: "#fff" }} aria-label="call">
                        <SendRoundedIcon className={vClasses.MainActionBtn}/>
                    </IconButton>

                </Paper>
            </form>
        </div>
    )

    return (
        <>
            <div className="container">

                <Modal show={showModal} handleClose={hideModalHandler}>
                    <div className={vClasses.ModalMsg}>
                        {MessagesComp}
                    </div>
                </Modal>

                {receivingCall && !callAccepted && <Modal show={true} handleClose={hideAnswerModalHandler}>
                    <div className={vClasses.ModalMsg}>
                        <div className="callContainer">

                            <div className="card">
                                <div className="header">
                                    <div className="animation">
                                        <span className="icon ring"/>
                                    </div>

                                    <p className="phoneNumber">{name}</p>
                                    <p className="calling">Calling</p>
                                </div>

                                <div className="footer">
                                    <div className="bouton raccrocher">
                                        <IconButton className="red" style={{color: "#870000"}} aria-label="call"
                                                    onClick={() => leaveCall()}>
                                            <CallEndIcon/>
                                        </IconButton>
                                    </div>
                                    <div className="bouton decrocher">
                                        <IconButton className="green" aria-label="call" onClick={() => answerCall()}>
                                            <CallRoundedIcon/>
                                        </IconButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
                }

                <div style={{display: `${showVideoContainer}`}} className={vClasses.VideoContainer}>
                    <div className={vClasses.MyVideoContainer}>

                        {stream && <video className={
                            `${flipped ? [vClasses.MyVideoFlipped, vClasses.MyVideo].join(' ') : vClasses.MyVideo}`
                        } playsInline muted ref={myVideo} autoPlay />}

                        {callAccepted && !callEnded ?
                            <video className={vClasses.MyVideo} playsInline ref={userVideo} autoPlay />:
                            null}

                        <div className={vClasses.MessageShow}>
                            {callAccepted && MessagesComp}
                        </div>

                    </div>
                </div>
            </div>

            <div className={navClasses.Navbar}>

                <Paper className={classes.root}>

                    {callAccepted && !callEnded ? (
                        <div style={{justifyContent: 'center'}} className={classes.root}>
                            <IconButton style={{ color: "#fff" }} aria-label="call" onClick={() => muteUnmute()}>
                                {
                                    muted ? <MicRoundedIcon /> : <MicOffRoundedIcon />
                                }
                            </IconButton>

                            <IconButton style={{ color: "#fff" }} aria-label="call" onClick={() => showHideVideo()}>
                                {
                                    showVideo ? <VideocamOffRoundedIcon /> : <VideocamIcon />
                                }
                            </IconButton>

                            <IconButton style={{ color: "#fff" }} aria-label="flip" onClick={flipVideoHandler}>
                                <FlipCameraAndroidRoundedIcon />
                            </IconButton>

                            <div className={vClasses.MsgIcon}>
                                <IconButton style={{ color: "#fff" }} aria-label="flip" onClick={showModalHandler}>
                                    <MessageIcon />
                                </IconButton>
                            </div>

                            <IconButton style={{ color: "#870000" }} aria-label="call" onClick={() => leaveCall()}>
                                <CallEndIcon/>
                            </IconButton>
                        </div>
                    ):(
                        <div style={{justifyContent: 'center'}} className={classes.root}>
                            <CopyToClipboard text={me}>
                                <Button className={classes.copyBtn} variant="contained" startIcon={<AssignmentIcon fontSize="small"/>}>
                                    Copy ID
                                </Button>
                            </CopyToClipboard>

                            <Divider className={classes.divider} orientation="vertical"/>

                            <form onSubmit={(e) => callUser(e, idToCall)}>
                                <InputBase
                                    className={classes.input}
                                    placeholder="Enter your partner's ID"
                                    inputProps={{'aria-label': 'Enter your partner\'s ID'}}
                                    value={idToCall}
                                    onChange={(e) => setIdToCall(e.target.value)}
                                />

                                <IconButton type='submit' style={{ color: "#fff" }} aria-label="call" >
                                    <CallRoundedIcon className={vClasses.MainActionBtn}/>
                                </IconButton>
                            </form>
                        </div>
                    )}
                </Paper>

            </div>
        </>
    );
}

export default VideoChat;
